module.exports = __webpack_public_path__ + "img/banner-1.f54e7885.jpg";